<div class="container">
  <div class="image-maintenance" title="Maintenance"></div>
  <div class="content">
    <h2>{{ 'maintenance-page.title' | translate }}</h2>
    <p>{{ 'maintenance-page.text' | translate }}</p>
  </div>
</div>
